import { axiosWithToken, axiosMultipart } from '../utils/functions/apiCallWithToken';
import { SERVER_URL as serverURL } from '../core/config';

export const setNftLike = async (assetId, nftId) => {
    const result = await axiosWithToken(`${serverURL}/nft/like/${assetId}/${nftId}`, 'post', {});
    return result;
}

export const fetchNftLike = async (page) => {
    const result = await axiosWithToken(`${serverURL}/nft/like/?page=${page}`, 'get', {});
    return result;
}

export const setNftDislike = async (nftId) => {
    const result = await axiosWithToken(`${serverURL}/nft/dislike/${nftId}`, 'delete', {});
    return result;
}

export const setNftWishlist = async (assetId, nftId) => {
    const result = await axiosWithToken(`${serverURL}/nft/wishlist/${assetId}/${nftId}/`, 'post', {});
    return result;
}

export const fetchNftWishlist = async (page) => {
    const result = await axiosWithToken(`${serverURL}/nft/wishlist/?page=${page}`, 'get', {});
    return result;
}

export const setNftDiswishlist = async (nftId) => {
    const result = await axiosWithToken(`${serverURL}/nft/dis-wishlist/${nftId}/`, 'delete', {});
    return result;
}

export const fetchNftBids = async () => {
    const result = await axiosWithToken(`${serverURL}/nft/bid/`, 'get', {});
    return result;
}

// §103 — createNFT retiré 2026-07-01 (audit #5) : frappe directe « Buy Now » historique,
// remplacée par le flux panier (mintPrimaryAsset). Route serveur débranchée. 0 appelant web.

export const admintNFT = async (assetId, data) => {
    const result = await axiosWithToken(`${serverURL}/nft/admint/${assetId}/`, 'post', data);
    return result;
}

export const fetchNFT = async (nftId) => {
    // {no404Redirect} (vague 4 lot 3) — fiche détail : 404 → ApiNotFoundError → loadFailed
    // → NotFoundBlock (remplace l'ex-rustine regex /nft/:id du transport). Jamais de redirect.
    const result = await axiosWithToken(`${serverURL}/nft/${nftId}/`, 'get', {}, {}, {}, { no404Redirect: true });
    return result;
}

export const fetchNFTs = async (params) => {
    const result = await axiosWithToken(`${serverURL}/nft/`, 'get', {}, params);
    return result;
}

export const addNFTListing = async (id, data) => {
    const result = await axiosWithToken(`${serverURL}/nft/add-listing/${id}/`, 'put', data);
    return result;
}

export const cancelNFTListing = async (id, data) => {
    const result = await axiosWithToken(`${serverURL}/nft/cancel-listing/${id}/`, 'put', data);
    return result;
}

export const buyNFT = async (id, data) => {
    const result = await axiosWithToken(`${serverURL}/nft/buy/${id}/`, 'put', data);
    return result;
}

export const transferNFT = async (id, data) => {
    const result = await axiosWithToken(`${serverURL}/nft/transfer/${id}/`, 'put', data);
    return result;
}

export const burnNFT = async (data) => {
    const result = await axiosWithToken(`${serverURL}/nft/burn/`, 'post', data);
    return result;
}

export const cancelNFT = async (data) => {
    const result = await axiosWithToken(`${serverURL}/nft/cancel/`, 'post', data);
    return result;
}

/**
 * Édition d'un EXEMPLAIRE (NFT) par son propriétaire (Lot B2).
 * Endpoint : PUT /nft/:id/custom (garde propriétaire côté serveur : userId === owner).
 * Liste blanche stricte côté back : customImage, customTitle, customDescription, price, saleType.
 * `null` sur un champ override = héritage du modèle-maître (copy-on-write §5/§9).
 *
 * §AES-GCM — passe par axiosWithToken (corps chiffré bout-en-bout), JAMAIS axios brut.
 * customImage attendu = chemin relatif servi par l'API (upload/…), obtenu via
 * uploadNftCustomImage ci-dessous, JAMAIS un blob URL local.
 *
 * @param {number|string} nftId
 * @param {{customImage?: string|null, customTitle?: string|null, customDescription?: string|null, price?: string|number, saleType?: string}} payload
 */
export const updateNftCustom = async (nftId, payload) => axiosWithToken(`${serverURL}/nft/${nftId}/custom`, 'put', payload, {});

/**
 * Upload de la photo « à la une » d'un exemplaire → renvoie le chemin relatif servi
 * par l'API (mécanisme identique à user.picture : fichier écrit sous upload/, servi
 * par express.static('upload'), puis résolu côté front par getUploadUrl()).
 *
 * Multipart direct (hors AES-GCM, comme TileService.uploadTileImage) : le fichier
 * binaire ne peut PAS transiter par axiosWithToken. Route serveur attendue :
 * POST /nft/:id/custom-image (garde propriétaire + validation image, exclue du
 * chiffrement de réponse), renvoyant { path: 'nft-custom/<id>/<file>' }.
 *
 * @param {number|string} nftId
 * @param {File} file
 * @returns {Promise<string>} chemin relatif à passer comme customImage
 */
export const uploadNftCustomImage = async (nftId, file) => {
    const formData = new FormData();
    formData.append('image', file);
    // Vague 4 lot 3 : multipart via le client central (route exclue AES-GCM, Bearer par requête).
    const res = await axiosMultipart(`${serverURL}/nft/${nftId}/custom-image`, 'post', formData);
    // Le back renvoie soit { path }, soit { customImage } — on accepte les deux formes.
    return res?.path || res?.customImage || '';
};